import {RETRIEVE_ATTACHMENT_LIST} from '@/api'
import {RETRIEVE_ATTACHMENT_USER_LIST} from '@/api'
import {CREATE_ATTACHMENT} from '@/api'
import {CREATE_ATTACHMENT_USER} from '@/api'
import {GET_ATTACHMENT_INFO} from '@/api'
import {EDIT_ATTACHMENT} from '@/api'
import {EDIT_ATTACHMENT_USER} from '@/api'
import {DELETE_ATTACHMENT} from '@/api'
import {GET_PICKUP_ROUTE_ATTACHMENT} from '@/api'
import {DELETE_ATTACHMENT_USER} from '@/api'
import {RETRIEVE_DROP_ROUTE_LIST} from '@/api'
import { UPDATE_ATTACHMENT_STATUS } from '@/api'
import {ATTACHMENT_TYPE_PICKUP_ROUTE, ATTACHMENT_TYPE_DROP_ROUTE} from '@/config'

export default {
  retrieveAttachmentList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_list.length) {
        commit('retrieveAttachmentList', {attachmentList: response.data.data.attachment_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_ATTACHMENT_LIST({}, successCallback, errorCallback)
  },

  retrieveAttachmentUserList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_user_list) {
        commit('retrieveAttachmentUserList', {attachmentUserList: response.data.data.attachment_user_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_ATTACHMENT_USER_LIST({}, successCallback, errorCallback)
  },

  retrievePickupRouteList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.pickup_route_list) {
        commit('retrievePickupRouteList', {pickupRouteList: response.data.data.pickup_route_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    GET_PICKUP_ROUTE_ATTACHMENT({}, successCallback, errorCallback)
  },

  retrieveDropRouteList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.drop_route_list) {
        commit('retrieveDropRouteList', {dropRouteList: response.data.data.drop_route_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_DROP_ROUTE_LIST({}, successCallback, errorCallback)
  },

  createAttachment({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_info) {
        commit('addAttachmentToList', {attachmentInfo: response.data.data.attachment_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback(response)
        }
      }
    };

    CREATE_ATTACHMENT({data: payload.data}, successCallback, errorCallback)
  },

  createAttachmentUser({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_user_info) {
        commit('addAttachmentUserToList', {attachmentUserInfo: response.data.data.attachment_user_info})

        if (typeof payload.successCallback === 'function') {
          payload.successCallback(response)
        }
      }
    };

    CREATE_ATTACHMENT_USER(payload, successCallback, errorCallback)
  },

  editAttachment({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_info) {
        commit('getAttachmentInfo', {attachmentInfo: response.data.data.attachment_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_ATTACHMENT({data: payload}, successCallback, errorCallback)
  },

  editAttachmentUser({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_user_info) {
        commit('getAttachmentUserInfo', {attachmentUserInfo: response.data.data.attachment_user_info})

        if (typeof payload.successCallback === 'function') {
          payload.successCallback(response)
        }
      }
    };

    EDIT_ATTACHMENT_USER({data: payload}, successCallback, errorCallback)
  },

  getAttachmentInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.attachment_info) {
        commit('getAttachmentInfo', {attachmentInfo: response.data.data.attachment_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_ATTACHMENT_INFO({payload}, successCallback, errorCallback)
  },

  deleteAttachment({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteAttachment', {attachmentInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_ATTACHMENT({payload}, successCallback, errorCallback)
  },

  deleteAttachmentUser({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      commit('deleteAttachmentUser', {attachmentUserInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_ATTACHMENT_USER({payload}, successCallback, errorCallback)
  },

  updateAttachmentStatus (state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    UPDATE_ATTACHMENT_STATUS(payload, successCallback, errorCallback)
  }
};
